:host {
  display: block;
}

#btn-back-to-top {
  --right: 22px;
  --bottom: 140px;
  --right_m: 20px;
  --bottom_m: 70px;
  position: fixed;
  border-radius: 50%;
  background: #fd5000;
  padding: 0;
  cursor: pointer;
  right: var(--right);
  bottom: var(--bottom);
  z-index: 2000;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: background-color .3s, opacity .5s, visibility .5s
}

#btn-back-to-top.active {
  opacity: 1;
  visibility: visible
}

#btn-back-to-top svg {
  fill: #fff;
  width: 35px;
  height: 35px
}

@media screen and (max-width: 768px) {
  #btn-back-to-top {
    right: var(--right_m);
    bottom: var(--bottom_m);
    height: 45px;
    width: 45px;
  }

  #btn-back-to-top svg {
    width: 25px;
    height: 25px
  }
}
